export default __webpack_public_path__ + "static/kubecon1-6905a59435b1e642cc93ee0f7efb155b.webp";